export const CONNECT_SOCKET = 'CONNECT_SOCKET';
export const CONVERSATION_MESSAGE_RECEIVED = 'CONVERSATION_MESSAGE_RECEIVED';
export const CARE_CONVERSATION_MESSAGE_RECEIVED = 'CARE_CONVERSATION_MESSAGE_RECEIVED';
export const SUPPORT_MESSAGE_RECEIVED = 'SUPPORT_MESSAGE_RECEIVED';
export const CARE_CONVERSATION_MESSAGE_NOTIFICATION = 'CARE_CONVERSATION_MESSAGE_NOTIFICATION';
export const PATIENT_CHECK_IN_EVENT_RECEIVED = 'PATIENT_CHECK_IN_EVENT_RECEIVED';
export const ISSUE_NOTIFICATION_RECEIVED = 'ISSUE_NOTIFICATION_RECEIVED';
export const PATIENT_CHECKED_IN = 'PATIENT_CHECKED_IN';
export const PATIENT_ONLINE_STATUSES_RECEIVED = 'PATIENT_ONLINE_STATUSES_RECEIVED';
